"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import '../../DataBuilderUI/FieldControlPanel/index.mjs';
import '../../DataBuilderUI/ActionBar.mjs';
import '../../DataBuilderUI/Cell.mjs';
import 'clsx';
import '../../DataBuilderUI/styles.module.css.mjs';
import '../../DataBuilderUI/Row.mjs';
import { Title } from '../../DataBuilderUI/Title.mjs';
import { fieldLabel } from '../data-field.mjs';
import { FieldDescription } from '../FieldDescription.mjs';
import { useLevelKeysConflicts } from '../Nested/use-level-keys-conflicts.mjs';
import useDataBuilder from '../use-data-builder.mjs';
import { FieldNameInput } from './FieldNameInput.mjs';

function FieldName({
  field,
  onKeyChange,
  onEnter,
  onEsc,
  rightSlot,
  typeSelectorSlot
}) {
  const { errorFieldsLocators } = useDataBuilder();
  const conflictedPropertiesKey = useLevelKeysConflicts();
  const { value, onChange } = useControlledInputValue(field.key || "", onKeyChange);
  if (field.isInSchema || field.key === void 0) {
    const isErrorField = field?.valueLocator && (errorFieldsLocators || []).includes(field.valueLocator);
    return /* @__PURE__ */ jsx(
      Title,
      {
        required: field.isRequired,
        hasValue: !!field.value || field.value === false,
        hasError: !!isErrorField,
        typeSelectorSlot,
        rightSlot: rightSlot || /* @__PURE__ */ jsx(FieldDescription, { text: field.schema?.description }),
        children: fieldLabel(field)
      }
    );
  } else {
    return /* @__PURE__ */ jsx(
      Title,
      {
        typeSelectorSlot,
        rightSlot: rightSlot || /* @__PURE__ */ jsx(FieldDescription, { text: field.schema?.description }),
        hasNameConflict: conflictedPropertiesKey.has(field.key),
        children: /* @__PURE__ */ jsx(
          FieldNameInput,
          {
            onChange,
            onEnter,
            onEsc,
            autoFocus: !field.key,
            value,
            onBlur: () => {
              onChange(field.key || "");
            },
            placeholder: "Enter field name"
          }
        )
      }
    );
  }
}
const useControlledInputValue = (value, onChange) => {
  const [inputValue, setInputValue] = useState(value);
  useEffect(() => {
    setInputValue(value);
  }, [value]);
  return {
    value: inputValue,
    onChange: (value2) => {
      setInputValue(value2);
      onChange(value2);
    }
  };
};

export { FieldName };
